<template>
  <div class="vs-row" :style="rowStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: "VsRow",
  props: {
    vsType: {
      type: String,
      default: "flex",
    },
    vsW: {
      type: [Number, String],
      default: 12,
    },
    vsJustify: {
      type: String,
      default: null,
    },
    vsAlign: {
      type: String,
      default: null,
    },
  },
  computed: {
    rowStyle() {
      return {
        alignItems: this.vsAlign,
        justifyContent: this.vsJustify,
        display: this.vsType,
        overflow: this.vsType === "block" ? "hidden" : null,
        width: `${(Number(this.vsW) * 100) / 12}%`,
      };
    },
  },
};
</script>
